import { Box } from '#/components/Box/Box';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { H1 } from '#/components/Text/H1';
import { useAppConfig } from '#/config/AppConfigContext';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  error: Error;
};

export function ErrorSection({ error }: Props) {
  const { i18n } = useI18n();
  const { appConfig } = useAppConfig();

  return (
    <>
      <H1>
        {
          /* TRANSLATORS: error page title */
          i18n('Something Went Wrong')
        }
      </H1>

      <Box mt={3}>
        {
          /* TRANSLATORS: error page title */
          i18n(
            "We're sorry, something went wrong. Please try again and if the problem persists, please {{link}}contact us{{/link}}.",
            {
              link: (
                <StyledNativeLinkWithRef href={i18n('/en/about/contact')} />
              ),
            },
          )
        }
      </Box>
      {appConfig.idealist.devStackTrace && error && (
        <Box mt={3} color="alertRed">
          {error.toString()}
          {error.stack}
        </Box>
      )}
    </>
  );
}
